export const receiptsEndpoints = {
  createReceipt: { method: 'post', path: '/' },
  getReceiptsByPurchaseOrderId: { method: 'get', path: '/by-purchase-order/{purchaseOrderId}' },
  getReceivedTotalsByPurchaseOrderId: { method: 'get', path: '/by-purchase-order/{purchaseOrderId}/received-totals' },
  voidReceiptLineItem: { method: 'post', path: '/line-items/{receiptLineItemId}/void' },
} as const
